import React from "react"
import { Layout } from "../components/Layout"
import { Heading } from "../components/Heading"
import "twin.macro"
import { IconButton } from "../components/IconButton"
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons"
import { Typography } from "../components/Typography"
import { BlurBG } from "../components/BlurBG"
import "twin.macro"
import { Slider } from "../components/Slider"
import { LoadableSketch } from "../sketches/LoadableSketch"
import { useSimulationData } from "../sketches/SimulationData.context"
import { PlanetData } from "../sketches/components/PlanetData.component"

const useAmount = (
  initialAmount: number,
  onAmountChange: (amount: number) => void,
  minAmount = 0,
  maxAmount = 100
) => {
  const [amount, setAmount] = React.useState(initialAmount)

  const increase = () => {
    amount < maxAmount &&
      setAmount(amount => {
        onAmountChange(amount + 1)
        return amount + 1
      })
  }

  const decrease = () => {
    amount > minAmount &&
      setAmount(amount => {
        onAmountChange(amount - 1)
        return amount - 1
      })
  }

  return {
    amount,
    increase,
    decrease,
    increaseDisabled: amount >= maxAmount,
    decreaseDisabled: amount <= minAmount,
  }
}

const AmountSwitch = ({
  initialAmount,
  onAmountChange,
}: {
  initialAmount: number
  onAmountChange: (amount: number) => void
}) => {
  const { amount, increase, decrease, increaseDisabled, decreaseDisabled } =
    useAmount(initialAmount, onAmountChange)

  return (
    <BlurBG tw="fixed right-0 bottom-0 m-4 p-2 flex items-center">
      <IconButton
        icon={faMinus}
        onClick={decrease}
        tw="mr-4"
        disabled={decreaseDisabled}
      />
      <Typography tw="w-8 text-center" variant="h3">
        {amount}
      </Typography>
      <IconButton
        icon={faPlus}
        onClick={increase}
        tw="ml-4"
        disabled={increaseDisabled}
      />
    </BlurBG>
  )
}

const SketchOverlay = ({
  defaultSpeed,
  defaultAmount,
}: {
  defaultSpeed: number
  defaultAmount: number
}) => {
  const { handleAmountChange, handleSpeedChange, nextPlanet, previousPlanet } =
    useSimulationData()

  return (
    <>
      <Heading title="MUSEUM" />
      <div tw="fixed left-0 bottom-0 m-4 p-2 h-60">
        <Slider
          minValue={0}
          maxValue={150}
          initialValue={defaultSpeed}
          onValueChange={handleSpeedChange}
        />
      </div>
      <AmountSwitch
        initialAmount={defaultAmount}
        onAmountChange={handleAmountChange}
      ></AmountSwitch>
      <PlanetData
        nextButtonClicked={nextPlanet}
        previousButtonClicked={previousPlanet}
      />
    </>
  )
}

export default function Museum() {
  const initialAmount = 80
  const initialSpeed = 5

  return (
    <Layout>
      <LoadableSketch defaultSpeed={initialSpeed} defaultAmount={initialAmount}>
        <SketchOverlay
          defaultSpeed={initialSpeed}
          defaultAmount={initialAmount}
        ></SketchOverlay>
      </LoadableSketch>
    </Layout>
  )
}
